"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriversCompanyStatus = void 0;
var DriversCompanyStatus;
(function (DriversCompanyStatus) {
    DriversCompanyStatus[DriversCompanyStatus["Hired"] = 0] = "Hired";
    DriversCompanyStatus[DriversCompanyStatus["Active"] = 1] = "Active";
    DriversCompanyStatus[DriversCompanyStatus["Declined"] = 2] = "Declined";
    DriversCompanyStatus[DriversCompanyStatus["Lead"] = 3] = "Lead";
})(DriversCompanyStatus || (exports.DriversCompanyStatus = DriversCompanyStatus = {}));
//# sourceMappingURL=DriversCompanyStatus.js.map